import { useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

export function useTheme() {
  const { currentUser } = useAuth();

  useEffect(() => {
    const loadTheme = async () => {
      if (currentUser?.uid) {
        try {
          const settingsDoc = await getDoc(doc(db, 'userSettings', currentUser.uid));
          if (settingsDoc.exists()) {
            const { theme } = settingsDoc.data();
            document.documentElement.className = theme;
          }
        } catch (error) {
          console.error('Failed to load theme:', error);
        }
      }
    };

    loadTheme();
  }, [currentUser]);
}